<template>
    <div class="flex items-center overflow-x-scroll gap-3 scroll-bar-none mx-auto p-2">
        <TabItem
            v-for="tab in tabs"
            :key="tab.value"
            :value="tab.value"
            :label="tab.label"
            :icon="tab.icon"
            :isActive="tab.value === active"
            @click="$emit('change', tab.value)"
        />
    </div>
</template>

<script>
import TabItem from './TabItem.vue';

export default {
    name: 'TabList',
    components: { TabItem },
    props: {
        tabs: {
            type: Array,
            required: true
        },
        active: {
            type: String,
            required: true
        },
    }
};
</script>
